import React from 'react';
import { Inbox } from 'lucide-react';

const UiEmptyState = ({
  icon: Icon = Inbox,
  title,
  subtitle = '',
  className = '',
}) => {
  return (
    <div className={`py-10 text-center text-gray-400 ${className}`}>
      <Icon size={40} className="mx-auto mb-3 opacity-50" />
      <p className="text-base font-medium text-gray-500">{title}</p>
      {subtitle ? <p className="mt-1 text-sm text-gray-400">{subtitle}</p> : null}
    </div>
  );
};

export default UiEmptyState;
